<template>
  <div class="tool-header" @click.stop>
    <div class="tool-header__left">
      <router-link class="tool-header__home" to="/">
        <i class="material-icons">home</i>
      </router-link>
      <template v-if="title">
        <span class="tool-header__separator">&raquo;</span>
        <span class="tool-header__title">{{ title }}</span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToolHeader",
  props: {
    title: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
$height: 64px;

.tool-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  height: $height;
  padding: 0 16px;
  color: inherit;
}

.tool-header__left {
  display: flex;
  align-items: center;
  font-size: 1.25rem;
}

.tool-header__home {
  display: flex;
  padding: 8px;
  text-decoration: none;
  color: inherit;

  .material-icons {
    font-size: 2rem;
  }

  @include transition(transform);

  &:hover {
    transform: scale(1.1);
  }
}

.tool-header__title {
  margin-left: 8px;
  font-weight: 500;
  font-variant: small-caps;
}
</style>
